import {EMPTY, Observable, of} from 'rxjs';
import {ProjectReferencePhotoService} from '../project-reference-photo.service';
import {ProjectReferencePhoto} from '../../models/project-reference-photo';
import {PhotoFocus} from '../../models/photo-focus';
import {PhotoPositionsRequest} from '../../models/photo-positions.request';

export const mockProjectReferencePhoto: ProjectReferencePhoto = {
    id: 1,
    position: 0,
    primary: true,
    photo: true,
    originalUrl: 'https://projectenportaal.acc.volkerwessels.dev/blob/00ccc455-2033-44d8-9e13-8f288fc2d5e5',
    focusX: 0,
    focusY: 0,
    width: 416,
    height: 416,
    srcset: {
        '416w': 'https://projectenportaal.acc.volkerwessels.dev/blob/00ccc455-2033-44d8-9e13-8f288fc2d5e5'
    }
};

export class ProjectReferencePhotoServiceMock implements ProjectReferencePhotoService {
    photos: ProjectReferencePhoto[] = Array.from({length: 6}).map((_, index) => ({
        ...mockProjectReferencePhoto,
        id: index + 1,
        position: index,
        primary: index === 0
    }));

    getPhotos(projectReferenceId: number): Observable<ProjectReferencePhoto[]> {
        return of(this.photos);
    }

    postPhoto(projectReferenceId: number, file: File): Observable<ProjectReferencePhoto> {
        const newPhoto: ProjectReferencePhoto = {
            id: this.photos.length + 1,
            position: this.photos.length + 1,
            primary: this.photos.length === 0,
            photo: true,
            originalUrl: 'https://www.youtube.com/watch?v=dQw4w9WgXcQ',
            focusX: 0,
            focusY: 0,
            height: 100,
            width: 100,
            srcset: {
                '100w': 'https://www.youtube.com/watch?v=dQw4w9WgXcQ'
            }
        };

        this.photos.push(newPhoto);

        return of(newPhoto);
    }

    deletePhoto(id: number): Observable<void> {
        this.photos = this.photos.filter(photo => photo.id !== id);

        return EMPTY;
    }

    putPositions(projectReferenceId: number, positions: PhotoPositionsRequest[]): Observable<ProjectReferencePhoto[]> {
        return of();
    }

    putFocusPoint(id: number, focus: PhotoFocus): Observable<ProjectReferencePhoto> {
        return of({
            id,
            position: 0,
            primary: true,
            photo: true,
            originalUrl: 'https://www.youtube.com/watch?v=dQw4w9WgXcQ',
            width: 100,
            height: 100,
            srcset: {
                '100w': 'https://www.youtube.com/watch?v=dQw4w9WgXcQ'
            },
            ...focus
        })
    }

    putPrimaryPhoto(projectReferenceId: number, projectReferencePhotoId: number): Observable<any> {
        this.photos = this.photos.map(photo => {
            if (photo.id === projectReferencePhotoId) {
                return {
                    ...photo,
                    primary: true
                };
            } else {
                return {
                    ...photo,
                    primary: false
                };
            }
        });

        return of(null);
    }
}
